import React from 'react';
import { Menu, Typography } from 'antd';

import DropdownItem from './DropdownState';
import DatePickerr from './DatePickerr';
import SearchInput from './SearchInput';
import DropdownState from './DropdownState';
import DropdownFilter from './DropdownFilter';

interface Props {
  handleDateValue: Function;
  handleStateValue: Function;
  handleFilterValue: Function;
  handleInputValue: Function;
}

const title = [
  // {
  //   title: '선택',
  //   value: ''
  // },
  {
    title: '일반회원',
    value: 'MEMBER'
  },
  {
    title: '가입신청자',
    value: 'SIGNUP_REQUEST'
  },
  {
    title: '수정신청자',
    value: 'AMENDMENT_REQUEST'
  },
  {
    title: '거절',
    value: 'REJECT'
  }
];

function FilterAction({
  handleDateValue,
  handleStateValue,
  handleFilterValue,
  handleInputValue
}: Props) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '9px',
        marginBottom: '21px'
      }}
      className="busk-filter-action"
    >
      <DatePickerr handleDateValue={handleDateValue} />
      <Typography.Text style={{ fontSize: '1rem' }}>상태</Typography.Text>
      <DropdownState
        filterBy={title}
        // //filter
        handleStateValue={handleStateValue}
      />

      <DropdownFilter
        df="선택"
        id="아이디"
        name="이름"
        registerAmazonAcc="아마존 계정 등록"
        //filter
        handleFilterValue={handleFilterValue}
      />
      <SearchInput handleInputValue={handleInputValue} />
    </div>
  );
}

export default FilterAction;
